import {AvScanStatus, AvScanStatusEnum} from 'av-scan/AvScanDAO';
import BenchlingConfig from 'BenchlingConfig';
import inspectAllNoteParts from 'notebook/notes/util/inspectAllNoteParts';
import {NoteLinkedFile, NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';
// @ts-expect-error: EntryStore is an untyped JS module
import EntryStore from 'stores/EntryStore';
import StageEntryStore from 'workflows/stage-entries/StageEntryStore';

function isNoteLinkedFile(notePart: NotePart): notePart is NotePart & {item: NoteLinkedFile} {
  const item = notePart.item;
  if (!item) {
    return false;
  }
  return 'type' in item && item.type === NoteLinkedObjectType.NOTE_LINKED_FILE;
}

export function getPendingAvScanFileNames(entryId: string): Array<string> {
  if (!BenchlingConfig.ENABLE_ANTIVIRUS_SCANNING) {
    return [];
  }

  const note = StageEntryStore.inStore(entryId)
    ? StageEntryStore.getNote(entryId)
    : EntryStore.inStore(entryId)
      ? EntryStore.getNote(entryId)
      : null;

  if (!note?.noteParts) {
    return [];
  }

  const pendingFileNames: Array<string> = [];
  inspectAllNoteParts(note.noteParts, (notePart) => {
    if (isNoteLinkedFile(notePart)) {
      if (notePart.item.externalFileExcerpt != null) {
        return;
      }
      const scanStatus: AvScanStatus | undefined = notePart.item.scanStatus;
      if (scanStatus === AvScanStatusEnum.PENDING) {
        pendingFileNames.push(notePart.item.name);
      }
    }
  });

  return pendingFileNames;
}
